import styled from 'styled-components';

import { colors, typography, spacing } from '../../../../styles/theme';

export const Table = styled.table`
  width: 100%;
  text-align: left;
  box-sizing: border-box;
  font-size: 16px;
  margin-bottom: ${spacing('10')};

  tr {
    border-bottom: 1px solid ${colors('black.08')};
  }

  th {
    font-weight: ${typography('weights.semibold')};
  }

  td,
  th {
    padding: ${spacing('small')} ${spacing('small')};
    vertical-align: middle;
  }
`;

interface StatusProps {
  status?: 'dispensed' | 'canceled-dispensation';
}

export const Status = styled.div<StatusProps>`
  border-radius: 8px;
  height: 21.5px;
  min-height: 21.5px;
  width: 80px;
  min-width: 80px;
  max-width: 80px;
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: center;

  color: ${({ status }: StatusProps) => {
    if (status === 'canceled-dispensation') return '#92400F';
    return '#166534';
  }};
  background-color: ${({ status }: StatusProps) => {
    if (status === 'canceled-dispensation') return '#FEF3C7';
    return '#DCFCE7';
  }};
`;
